export default __webpack_public_path__ + "static/media/80.f9174d11.svg";